import WebsiteModal from "modal/WebsiteModal";
import {handleHubspotForm} from "util/hubspot";

export default class ImplementationPersonModal extends WebsiteModal {
    constructor(data) {
        super();
        this.data = data;

        this.translations = {};

        if ($(".js-implementation-translations").length > 0) {
            try {
                this.translations = JSON.parse($(".js-implementation-translations").text());
            } catch (e) {
                console.warn("Couldn't load data from page", e);
            }
        }
    }

    buildElement() {
        this.$modal = (
            eotwJSXFactory('div', {className: "modal modal--implementation"}, [
                eotwJSXFactory('div', {className: "modal__bg js-modal-close"}),
                eotwJSXFactory('div', {className: "modal__container"}, [
                    eotwJSXFactory('button', {className: "modal__close js-modal-close"}),
                    eotwJSXFactory('div', {className: "modal__content modal__content--small content-section js-hubspot-form"}, [
                        eotwJSXFactory('h2', {className: "heading heading--2"}, [this.translations.title, " ", this.data.name]),
                        eotwJSXFactory('p', null, [this.translations.text, " ", this.data.name, "."]),
                        eotwJSXFactory('div', {className: "js-hubspot-container hubspot-container", 'data-hubspot-class': "contact", 'data-portal-id': "2188024", 'data-form-id': this.data['hubspot_form_id']})
                    ])
                ])
            ])
        );

        handleHubspotForm(this.$modal.find('.js-hubspot-form'));
    }

    show() {
        super.show();
    }
}


